module.exports = {
	"about": "විස්තර",
	"accepted_invitation_from": "ඔබ {invitedBy} }ගේ ආරාධනය පිළිගෙන බෝනස් කාසි {coins}ක් දිනා ඇත.",
	"accepted_invitation_from_friend": "ඔබේ මිතුරා {displayName} ඔබගේ ආරාධනය පිළිගෙන ඇත. ඒ වෙනුවෙන් ඔබ බෝනස් කාසි {coins}ක් දිනා ඇත.",
	"account_disabled": "ඔබේ ගිණුම ක්‍රියාවිරහිත වී ඇත. කරුණාකර hello@cricrush.com සම්බන්ධ කරගන්න.",
	"all_entries": "සියලු ලංසු",
	"already_registered": "ඔබ දැනටමත් ලියාපදිංචි වී තිබේද?",
	"can_t_find_account": "අය්යෝ, අපට ඔබගේ ගිණුම සොයාගත නොහැක. කරුණාකර ගිණුමක් සාදන්න!",
	"cant_placed_entries": "ඔබ කිසිදු ලන්සුවක් ඇතුලත් කර නැත",
	"change_profile_picture": "ගිණුම් ඡායාරූපය වෙනස් කරන්න",
	"chat_modal_name": "චැට් කරන්න",
	"claim": " හිමිකර ගන්න",
	"click_here_to_resend": "ස්ථිර කිරීම නැවත එවන්න",
	"close": "වසා දමන්න",
	"coming_soon": "ළඟදීම එනවා",
	"confirm": " ස්ථිර කරන්න",
	"countdown_day": "දවස",
	"countdown_days": "දින",
	"countdown_hours": "පැය",
	"countdown_minutes": "මිනිත්තු",
	"countdown_seconds": "තත්පර",
	"create_account": "ගිණුම සාදන්න",
	"cricrush_league": "Cricrush ලීගය",
	"do_not_have_an_account": "ඔබට දැනට  ගිණුමක් නැත්ද?",
	"dream_team": "සිහින කණ්ඩායම",
	"dream_team_entry": "සිහින කණ්ඩායමේ ලංසුව",
	"dream_team_entry_creation_modal_name": "සිහින කණ්ඩායමේ ලංසුව සෑදීම",
	"dream_team_leagues": "සිහින කණ්ඩායම් ලීග",
	"earn_coins_bonuses": "බෝනස් කාසි හිමිකරගන්න",
	"edition": "සංස්කරණය",
	"email_not_verified": "විද්‍යුත් ලිපිනය තහුවුරු කර නැත.",
	"email_not_verified_to_claim_rewards": "ත්‍යාග හිමිකරගැනීම සඳහා විද්‍යුත් ලිපිනය තහවුරු  කරන්න.",
	"email_title": "විද්‍යුත් ලිපිනය",
	"enter_valid_email": "වලංගු විද්‍යුත් ලිපිනයක් ඇතුලත් කරන්න",
	"entries": "ලංසු",
	"entry_created": "ලංසුව සාදන ලදී",
	"favourite_teams": "ප්‍රියතම කණ්ඩායම්",
	"fb_reauth": "Facebook සමඟ ස්ථිර කරන්න",
	"fb_signin": "Facebook මගින් පිවිසෙන්න",
	"fb_signup": "Facebook මගින් ලියාපදිංචි වන්න",
	"fire_base_already_login_different provider": "ඔබ වෙනත් සැපයුම්කරුවෙක් භාවිතා කර ලියාපදිංචි වී ඇත. කරුණාකර නිවැරදි සැපයුම්කරු භාවිතා කර පිවිසෙන්න.",
	"fire_base_wrong_message": "යමක් වැරදී ඇත. කරුණාකර පසුව යලිත් උත්සාහ කරන්න!",
	"friend_invite_accepted": " ඔබේ මිතුරා {friendName} ඔබේ ආරාධනය පිළිගෙන ඇත",
	"ggl_reauth": "Google සමඟ ස්ථිර කරන්න",
	"ggl_signin": "Google මගින් පිවිසෙන්න",
	"ggl_signup": "Google මගින් ලියාපදිංචි වන්න",
	"go_back": "ආපස්සට යන්න",
	"help": "උදවු",
	"invalid_mail": "අවලංගු විද්‍යුත් ලිපිනය",
	"invitation_accepted": "ආරාධනය පිළිගන්නා ලදී!",
	"invitation_bonus": "ආරාධනා බෝනස්",
	"invite_friends": "මිතුරන්ට ආරාධනා කරන්න",
	"leaderboard": "නායක පුවරුව",
	"live": "Live",
	"live_prediction": "සජීවී අනුමාන ලීගය",
	"live_prediction_entry": "සජීවී අනුමාන ලංසු",
	"login": "පිවිසෙන්න",
	"login_here": "මෙතනින් පිවිසෙන්න",
	"login_register": "පිවිසෙන්න / ලියාපදිංචි වන්න",
	"logout": "ඉවත් වන්න",
	"lost": "නැතිවුන",
	"lost_title": "නැතිවුන",
	"no_email_with_account": "මේ විද්‍යුත් ලිපිනය සමඟ සම්බන්ධ වූ ගිණුමක් නොමැත. කරුණාකර ලියාපදිංචි වන්න",
	"no_network": "අන්තර්ජාල සම්න්බන්ධතාවය අඩාල වී ඇත! ",
	"no_network_connection": "අන්තර්ජාල සම්න්බන්ධතාවය අඩාල වී ඇත!",
	"notifications": "දැනුම්දීම්",
	"or": "හෝ",
	"password_incorrect": " ඔබ ඇතුලත් කල මුරපදය වැරදිය.",
	"pick_your_country": "ඔබේ රට තෝරා ගන්න",
	"play_button": "තරඟ කරන්න",
	"predict_score": "තරඟයේ අවසන් ලකුණු අනුමාන කරන්න",
	"profile": "ගිණුම",
	"providers_str": "ඔබ පෙර වතාවකදී  {providersStr} භාවිතා  කලා. එම ක්‍රම වලින් එකක් භාවිතා කර නැවත පිවිසෙන්න",
	"providers_str_try_google": "ඔබ පෙර {providersStr} භාවිතා කර ලියාපදිංචි වී ඇත. කරුණාකර Google භාවිතා කර පිවිසීමට උත්සාහ කරන්න",
	"reauth_modal_title": "ක්‍රියාව සම්පුර්ණ කිරීමට පිවිසුම නැවත සහතික කරන්න",
	"received_invitation_bonus": "ආරාධනා බෝනස් ලැබුණි",
	"refunded": "මුදල් ආපසු දෙන ලදී",
	"refunded_title": "මුදල් ආපසු දෙන ලදී",
	"register_here": "මෙතනින් ලියාපදිංචි වන්න",
	"save": "සුරකින්න",
	"select_country": "රට තෝරා එයට විශේෂිත  වූ ත්‍යාග ලබාගන්න!",
	"select_language": "භාෂාව තෝරන්න",
	"select_teams": "ප්‍රියතම කණ්ඩායම්",
	"settings": "සැකසුම්",
	"submit": "යොමු කරන්න",
	"target_prediction": "ලකුණු අනුමානය",
	"target_prediction_entry": "ලකුණු අනුමාන ලංසුව",
	"total": "එකතුව",
	"transactions": "ගණුදෙනු",
	"unknown_error": "නොදන්නා ගැටළුවක් පැන නැගිණි. කරුණාකර hello@cricrush.com හරහා අපව සම්බන්ද කරගන්න",
	"upcoming": "එළඹෙන තරඟ",
	"user_name": "පරිශීලක නාමය",
	"valid_number": "කරුණාකර වලංගු අංකයක් ඇතුලත් කරන්න!",
	"weak_password": "මුරපදය අනාරක්ෂිතයි. අක්ෂර 6ක් හෝ ඊට වැඩි මුර පදයක් තෝරා ගන්න",
	"won": "ජයගත්තා",
	"won_lost_refunded_coins": "ඔබ විසින් {earnedCoins} මුදලක් දිනන අතර {lostCoins} මුදලක් අහිමි කරගත්තා. ඊට අමතරව {refundedCoins} මුදලක් නැවත ලබාගන්නා ලදී",
	"won_title": "ජයගත්තා",
	"you_lost_message": "ඔබ පරාදයි",
	"you_won": "ඔබ ජයගත්තා",
	"you_won_reward": "ඔබ ත්‍යාගයක් දිනා ඇත",
	"your_entries": "ඔබගේ ලංසු",
	"your_live_prediction_entry": "ඔබගේ සජීවී අනුමාන ලන්සුව: {prediction}",
	"your_mom_entry": "ඔබගේ 'තරඟයේ වීරයා' අනුමාන ලංසුව: {momEntry}",
	"your_prediction": "ඔබේ අනුමානය : {prediction}",
	"display_name": "ප්‍රදර්ශණ නාමය",
	"email": "විද්‍යුත් ලිපිනය",
	"password": "මුරපදය",
	"runs_cannot_be_negative_value": "ලකුණු ඍණ අගයක් විය නොහැක",
	"budget": "අයවැය",
	"view_button": " බලන්න",
	"score": "ලකුණු: ",
	"rank": "ශ්‍රේණිය: ",
	"target_prediction_leagues": "අවසාන ලකුණු අනුමාන කරන ලීග",
	"live_prediction_leagues": "සජීවී තරග අනුමාන ලීග",
	"target_prediction_description": "තරගයේ අවසන් ලකුණු අනුමාන කර ඔබගේ ලංසු තබන්න. සත්‍ය ලකුණු ප්‍රමාණයට ඇති සමීපතාවය මත ලංසු ශ්‍රේණිගත කරනු ඇත",
	"required": "අත්‍යවශයි!",
	"entries_left": " ඉතිරිව ඇති ලංසු ගණන",
	"end_of_results": "ප්‍රතිපල වල අවසානය",
	"invalid_email_address": "අවලංගු විද්‍යුත් ලිපිනයකි",
	"completed": "සම්පුර්ණයි",
	"dream_team_description": "ඔබගේ ක්‍රීඩකයන් 4 දෙනාගේ කණ්ඩායම තෝරාගෙන ඔබගේ ලංසු නිර්මාණය කරන්න. දැන් ඔබගේ කණ්ඩායම ඔබ වෙනුවෙන් ලකුණු ලබාගන්නවා දැකගන්න.",
	"reward_claimed_title": "ත්‍යාගය හිමිකරගත්තා  - {reference}",
	"reward_claimed_msg": "නිර්දේශනය සමඟ ත්‍යාගය හිමිකරගෙන මුදල් ලබාගත්තා",
	"update": "යාවත්කාලින කිරීම ",
	"processed": "සකසන ලදී",
	"claim_reward_instructions_title": "කරුණාකර උපදෙස් හොදින් කියවන්න",
	"invalid_filed_instruction": " {field} වලංගු නොවේ. කරුණාකර පරික්ෂා කරන්න",
	"reward_processed": "ත්‍යාග සකසන ලදී!",
	"reward_reference": "ඔබගේ නිර්දේශනය : {reference}",
	"claim_coins_message": "මෙම ත්‍යාගය  හිමිකරගැනීමෙන් ඔබගේ කාසි {claimCoins} අඩුවනු ඇත.",
	"weekly": "සතිපතා",
	"daily": "දිනපතා",
	"monthly": "මාස්පතා",
	"lifetime": " දිවි ඇති තුරා",
	"local": "දේශීය",
	"global": "ලොවපුරා",
	"no_lb_status_generated": "මෙම නායක පුවරුව සෑදීමට අපට අවශ්‍ය තරමට දත්ත නොමැත!",
	"you": "ඔබ",
	"leaderBoard": "නායක පුවරුව",
	"mail_sent": "විද්‍යුත් තැපෑල යවනු ලැබිණ!",
	"verification_mail_sent": "තහවුරු කිරීමේ ලිපියක් ඔබේ {email} විද්‍යුත් ලිපිනයට යවනු ලැබිණ",
	"messages": "පණිවිඩ",
	"country_change_warning": "ඔබ රට වෙනස් කළහොත් නායක පුවරුවේ  දැනට පවතින ශ්‍රේණිගත කිරීම අහිමි වනු ඇත.",
	"faq": "නිතර අසන ප්‍රශ්න",
	"how_scores_calculated": "ලකුණු ගණනය කරන ආකාරය ",
	"how_to_play": "තරඟ කරන ආකාරය",
	"live_prediction_description": "කණ්ඩායමේ {endOver} වන පන්දුවාරය අවසානයේ ලකුණු ගණන අනුමාන කරන්න. සත්‍ය ලකුණු ප්‍රමාණයට ඇති සමීපතාවය මත ඔබගේ ලංසු ශ්‍රේණිගත කරනු ඇත.",
	"predict_what_message": "{teamName} කණ්ඩායමේ {endOver} වන පන්දුවාරය අවසානයේ ලකුණු ගණන අනුමාන කරන්න.",
	"pick_team": "ඔබගේ සිවු දෙනෙකුගෙන් යුත් කණ්ඩායම තෝරා ගෙන දිනන්න",
	"your_entry_created": "ඔබගේ ලන්සුව ඇතුලත් කෙරුනා!",
	"fica_title": "නිල වශයෙන් අනුමත කලේ",
	"fica_detailed_text": "FICA මගින් අනුමත කල එකම ජංගම මෘදුකාංගය Cricrush වේ",
	"version": "අනුවාදය",
	"match_help": "Click here to select a match",
	"dream_team_leagues_help": "Click here to select your 4 player team for {matchName}",
	"quick_prediction_leagues_help": "Click here to predict the score at the end of {over}th over",
	"target_prediction_leagues_help": "Click here to predict the target score of {matchName} match",
	"entries_help": "Click here to view your entry scores and ranks updated in real time with live match",
	"more_leaderboard_help": "Click here to check your leaderboard",
	"more_edition_language_help": "Click here and select edition to change your language",
	"more_edition_country_help": "Click here and select edition to change your country",
	"add_coins_help": "Running out of coins? Earn more free coins here",
	"claimed": "Claimed",
	"invite_friends_title": "Invite your friends and get 100 coins when they place their first entry!",
	"daily_claim_bonus_counter_message": "You have already claimed your bonus!",
	"daily_claim_bonus_message": "Claim your free coins now!",
	"daily_login_bonus": "Daily login bonus",
	"daily_login_bonus_claimed": "Daily login bonus claimed",
	"invite_friends_share_title": "Your friend {name} has invited you to join Cricrush",
	"invite_friends_share_message": "Your friend {name} has invited you to join Cricrush. Click the link below to join, play and win exciting gifts",
	"invite_friends_dialog_title": "Invite friends to join",
	"live_status": "LIVE",
	"view_entries": "View {noOfEntries} entries >>",
	"end_of_results2": "That's all we have!",
	"leagues_not_created": "Leagues will be created soon...",
	"add_coins": "Add Coins",
	"expired": "Expired",
	"reward_expired": "Reward Expired!",
	"entries_left2": "{noOfEntries} ඉතිරිව ඇති ලංසු ගණන"
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/si.json
// module id = 488
// module chunks = 0